const blank = (props) => props.children;

export default blank;


// WEBPACK FOOTER //
// ./src/hoc/Blank/Blank.js